import React from 'react';
import {API} from "aws-amplify";
import {toast} from "react-toastify";

export default function MasqWarning({tenantName }){
    const switchBack = () => {
        API.post('Core', '/api/v1/support-tools/assume/switch-back')
            .then(response => {
                    toast.success("Switching Back!", {position: "top-center"});
                    if (window.__RUNTIME_CONFIG__?.EID_DELEGATION_ENABLED === 'true') {
                        sessionStorage.setItem('eid_switched_back', 'true');
                    }
                    window.location = "/";
                },
                error => {
                    toast.error("Could not switch back: " + error.response.data.message, {position: "top-center"});
                }
            );
    }

    return (
        <div id="masq-alert">
            <span className="alert">
               CAUTION - YOU ARE EXPLORING AN ACCOUNT
                <br/>
                <button onClick={switchBack} aria-label="Switch back to your account">Switch Back</button>
            </span>

        </div>
    )
}